module.exports = function (area) {
    return {
        event: 'BWSAUlogin',
        eventContext: {
            area
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/login/login-analytics-mapper.js
 **/